export const PostTypes = {
  c0: [
    "Green fee offers",
    "assets/img/ic_push_checked_c0.png",
    "assets/img/ic_push_unchecked_c0.png",
  ],
  c1: [
    "Course update",
    "assets/img/ic_push_checked_c1.png",
    "assets/img/ic_push_unchecked_c1.png",
  ],
  c2: [
    "Golf events",
    "assets/img/ic_push_checked_c2.png",
    "assets/img/ic_push_unchecked_c2.png",
  ],
  c3: [
    "Pro-ams",
    "assets/img/ic_push_checked_c3.png",
    "assets/img/ic_push_unchecked_c3.png",
  ],
  c4: [
    "Entertainment",
    "assets/img/ic_push_checked_c4.png",
    "assets/img/ic_push_unchecked_c4.png",
  ],
  c5: [
    "Society info",
    "assets/img/ic_push_checked_c5.png",
    "assets/img/ic_push_unchecked_c5.png",
  ],
  c6: [
    "Membership info",
    "assets/img/ic_push_checked_c6.png",
    "assets/img/ic_push_unchecked_c6.png",
  ],
  c7: [
    "Pro shop promotions",
    "assets/img/ic_push_checked_c7.png",
    "assets/img/ic_push_unchecked_c7.png",
  ],
  c8: [
    "Hotel and Spa deals",
    "assets/img/ic_push_checked_club_c8.png",
    "assets/img/ic_push_unchecked_club_c8.png",
  ],
  c9: [
    "Golf holiday packages",
    "assets/img/ic_push_checked_club_c9.png",
    "assets/img/ic_push_unchecked_club_c9.png",
  ],
  c10: [
    "Club demo days",
    "assets/img/ic_push_checked_club_c10.png",
    "assets/img/ic_push_unchecked_club_c10.png",
  ],
  c11: [
    "Gym info",
    "assets/img/ic_push_checked_club_c11.png",
    "assets/img/ic_push_unchecked_club_c11.png",
  ],
  c12: [
    "Driving range info",
    "assets/img/ic_push_checked_club_c12.png",
    "assets/img/ic_push_unchecked_club_c12.png",
  ],
  c13: [
    "Lessons offers",
    "assets/img/ic_push_checked_club_c13.png",
    "assets/img/ic_push_unchecked_club_c13.png",
  ],
  c14: [
    "Ladies info",
    "assets/img/ic_push_checked_club_c14.png",
    "assets/img/ic_push_unchecked_club_c14.png",
  ],
  c15: [
    "Seniors info",
    "assets/img/ic_push_checked_club_c15.png",
    "assets/img/ic_push_unchecked_club_c15.png",
  ],
  c16: [
    "Food and Beverage",
    "assets/img/ic_push_checked_club_c16.png",
    "assets/img/ic_push_unchecked_club_c16.png",
  ],
  c17: [
    "Junior info",
    "assets/img/ic_push_checked_club_c17.png",
    "assets/img/ic_push_unchecked_club_c17.png",
  ],
};

export const AdminPostTypes = {
  a0: ["New Clubs", "assets/img/a0.png", "assets/img/a0_un.png"],
  a1: ["Golfhubber Tour", "assets/img/a1.png", "assets/img/a1_un.png"],
  a2: ["Golf Fitness", "assets/img/a2.png", "assets/img/a2_un.png"],
  a3: ["New Features", "assets/img/a3.png", "assets/img/a3_un.png"],
  a4: ["Promotions", "assets/img/a4.png", "assets/img/a4_un.png"],
  a5: ["Equipment", "assets/img/a5.png", "assets/img/a5_un.png"],
  a6: ["Pro's Tips", "assets/img/a6.png", "assets/img/a6_un.png"],
  a7: ["Events", "assets/img/a7.png", "assets/img/a7_un.png"],
};
